/**
 * @fileoverview ConstUtil util
 */
'use strict';
// Const Import
import Common from '../const/CommonConst';
import Message from '../const/MessageConst';

/**
 * メッセージ取得
 *
 * @param {*} resultCode
 */
const resultCodeMessage = resultCode => {
  let message = Message.RESULT_CODE[resultCode];
  if (message === undefined) {
    message = Message.RESULT_CODE[9];
  }
  return message;
};

export { Common, Message, resultCodeMessage };



// WEBPACK FOOTER //
// ./src/js/util/ConstUtil.jsx